import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, categoryMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryMap[slug] : undefined;
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
          <h1 className="font-heading text-3xl font-bold text-foreground-900 mb-4">分类未找到</h1>
          <p className="text-foreground-500 mb-6">抱歉，您访问的分类不存在。</p>
          <Link
            to="/"
            className="inline-flex px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 亚洲一区`,
    description: category.description,
    url: `https://jianfenxiansheng.cn/category/${category.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '亚洲一区',
      url: 'https://jianfenxiansheng.cn',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <div className="mb-10">
            <div className="flex items-center gap-4 mb-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-foreground-500 text-sm ml-16">{category.description}</p>
          </div>

          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-400">该分类暂无内容，敬请期待。</p>
            </div>
          )}
        </main>
        <Footer />
      </div>
    </>
  );
}